import * as accountRequestAPI from 'login-apis/accountRequestAPI';
import { DataShape, SubmissionError } from 'redux-form';
import { setHref, WindowWrapper } from 'login-utils/globalWrappers';
import * as _ from 'lodash';

export async function submitBorrowerActivationRequest(formValues: DataShape) {
  // Explicitly excluding the matching password.
  const params: accountRequestAPI.BorrowerActivationParams = {
    acceptTermsAndEConsent: formValues.acceptTermsOfServiceAndEConsent,
    last4SSN: formValues.last4SSN,
    password: formValues.password,
    username: formValues.username,
  };

  try {
    // Try borrower activation.
    const res = await accountRequestAPI.activateBorrower(params);
    if (res.data.redirectUrl) {
      // if redirectUrl is provided, redirect borrower to the redirectUrl
      setHref(res.data.redirectUrl);
    } else {
      // On success, their session will be recreated; refresh the page to have
      // the backend serve the correct next stage.
      WindowWrapper.location.reload();
    }
  } catch (err) {
    const defaultError = 'There was an error activating your account.';
    throw new SubmissionError({ _error: _.get(err, 'response.data', defaultError) });
  }
}

export async function submitLenderActivationRequest(submitValues: accountRequestAPI.LenderActivationParams) {
  try {
    return await accountRequestAPI.submit('activation', submitValues);
  } catch (err) {
    const errMsg = _.get(err, 'response.data', 'There was an error activating your account.');
    throw new SubmissionError({ _error: errMsg });
  }
}
